import { render, staticRenderFns } from "./roleForm.vue?vue&type=template&id=484f376c&scoped=true&"
import script from "./roleForm.vue?vue&type=script&lang=js&"
export * from "./roleForm.vue?vue&type=script&lang=js&"
import style0 from "./roleForm.vue?vue&type=style&index=0&id=484f376c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484f376c",
  null
  
)

export default component.exports